import React from 'react'
import Link from 'gatsby-link'
import Feedback from '../components/UI/Feedback';

const NotFoundPage = () => (
      <div style={{width: '100%', alignItems: 'center'}}>
          <div style={{padding: '20px 40px 20px 30px', margin: '140px 0px 100px 0px', maxWidth: 600, width: '90%', textAlign: 'center', display: 'inline-block', backgroundColor: 'rgba(0, 0, 0, 0.7)'}}>
              <Feedback note={'Loading...'} icon={'loading'}/>
          </div>
      </div>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js